export const kMovableValueClass = "movable-value"
export const kMovableValueType = "Movable Value"
export const kMovableValuePrefix = "ADRN"
export const kMovableValueLabelKey = "DG.Inspector.graphMovableValue"
export const kMovableValueUndoAddKey = "DG.Undo.graph.addMovableValue"
export const kMovableValueRedoAddKey = "DG.Redo.graph.addMovableValue"
export const kMovableValueUndoRemoveKey = "DG.Undo.graph.removeMovableValue"
export const kMovableValueRedoRemoveKey = "DG.Redo.graph.moveMovableValue"

